export default __webpack_public_path__ + "static/media/sim-san-marino.05875c77.jpg";